// extracted by mini-css-extract-plugin
export default {"card":"ShoppingList_card__5HGb3"};